/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const containerStyles = css`
    margin: 0 auto;
    max-width: 500px;
`;

const slideStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;

    img {
        border-radius: 10px;
        overflow: hidden;
        max-width: 260px;
        min-width: 260px;
        height: 400px;
        object-fit: cover;
    }
`;

const Slideshow = ({ imageUrls = [] }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && imageUrls.length > 1) {
            const swiperInstance = swiperRef.current.swiper;

            // Aguarda o Swiper estar completamente inicializado
            swiperInstance.on('init', () => {
                if (swiperInstance.autoplay) {
                    swiperInstance.autoplay.start();
                }
            });

            // Atualiza o Swiper com as novas imagens
            swiperInstance.update();
        }
    }, [imageUrls]);

    if (imageUrls.length === 0)
        return (
            <Box
                alignItems="center"
                borderRadius="4px"
                display="flex"
                justifyContent="center"
                height="400px"
                margin="0 auto"
                sx={{ border: 'solid 1px #5947a6' }}
                width="260px"
            >
                <ImageOutlinedIcon />
            </Box>
        );

    return (
        <div css={containerStyles}>
            <Swiper
                ref={swiperRef}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                centeredSlides
                coverflowEffect={{
                    slideShadows: false,
                }}
                effect="coverflow"
                loop
                modules={[Autoplay, EffectCoverflow]}
                slidesPerView={imageUrls.length > 3 ? 2 : 1} // Só pode ser igual a dois se houver 4 ou mais imagens. Caso contrário, deve ser 1.
                onSwiper={(swiper) => {
                    // Inicia o autoplay no momento em que o Swiper é configurado
                    if (swiper.autoplay) {
                        swiper.autoplay.start();
                    }
                }}
            >
                {imageUrls.map((imageUrl, index) => (
                    <SwiperSlide key={`image-${index}`}>
                        <div css={slideStyles}>
                            <img src={imageUrl} alt={`Slide ${index}`} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Slideshow;
